import tracking from 'src/tracking'

import { TagVariant } from '../../components/atoms/Tag/styled'
import { HeroProps } from '../../components/molecules/Hero'
import type { Recipe } from '../../graphql/generated/api-graphql'
import { toScoreLetter } from '../Common/recipe'
import { wediaImagesTransform } from '../Common/wedia'
import routes from '../../routes/definitions'
import Router from '../../routes/Router'
import { transformTimeToMinutes } from '../../helpers/DateHelpers'

const RecipeHeroTransform = (t: any, data: Recipe): HeroProps => {
  const dateOlderRecipes = '2016-11-18 00:00:00'
  const hasOlderImage =
    dateOlderRecipes &&
    data.publicationDate &&
    new Date(dateOlderRecipes) > new Date(data.publicationDate)

  const duration = data?.preparationTime
    ? transformTimeToMinutes(data.preparationTime)
    : 0

  return {
    title: data?.title,
    imageProps: {
      maxWidth: 1280,
      width: 1280,
      height: 512,
      withHD: true,
      withLazyLoading: false,
      preload: true,
      alt: data?.title ?? data.mainImage?.alt,
      images:
        hasOlderImage && data.thumbnail01
          ? wediaImagesTransform(data.thumbnail01)
          : data.mainImage
          ? wediaImagesTransform(data.mainImage)
          : undefined,
    },
    mobileImageProps: {
      maxWidth: 370,
      width: 370,
      height: 200,
      withHD: true,
      withLazyLoading: false,
      preload: true,
      alt: data?.title ?? data.mainImage?.alt,
      images:
        hasOlderImage && data.thumbnail01
          ? wediaImagesTransform(data.thumbnail01)
          : data.mainImage
          ? wediaImagesTransform(data.mainImage)
          : undefined,
    },
    brandLogoProps: data.brand?.pictureLogo
      ? {
          maxWidth: 120,
          width: 80,
          height: 80,
          withHD: true,
          withLazyLoading: false,
          alt: data?.brand?.name,
          images: data.brand.pictureLogo
            ? wediaImagesTransform(data.brand.pictureLogo)
            : undefined,
        }
      : undefined,
    bottomTags: [
      // drop all the tags in order then slice the first 2
      ...(data?.positiveFood
        ? [
            {
              label: t('positive_food'),
              href: Router.getRouteUrl(routes.tag.name, {
                slug: 'positivefood',
              }),
              variant: TagVariant.positive,
              onClick: () => tracking.tag(t('positive_food'), data.title),
            },
          ]
        : []),
      ...(data?.tagsConsumptionTime?.[0]
        ? [
            {
              label: data?.tagsConsumptionTime?.[0]?.name,
              href: Router.getRouteUrl(routes.tag.name, {
                slug: data.tagsConsumptionTime[0].slug,
              }),
              variant: TagVariant.meal,
              onClick: () =>
                tracking.tag(data?.tagsConsumptionTime?.[0]?.name, data.title),
            },
          ]
        : []),
      ...(data?.tagsDifficulty?.[0]
        ? [
            {
              label: data?.tagsDifficulty?.[0]?.name,
              href: Router.getRouteUrl(routes.tag.name, {
                slug: data.tagsDifficulty[0].slug,
              }),
              variant: TagVariant.primary,
              onClick: () =>
                tracking.tag(data?.tagsDifficulty?.[0]?.name, data.title),
            },
          ]
        : []),
      ...(data?.tagsTheme?.[0]
        ? [
            {
              label: data?.tagsTheme?.[0]?.name,
              href: Router.getRouteUrl(routes.tag.name, {
                slug: data.tagsTheme[0].slug,
              }),
              variant: TagVariant.meal,
              onClick: () =>
                tracking.tag(data?.tagsTheme?.[0]?.name, data.title),
            },
          ]
        : []),
    ].slice(0, 2),
    score: {
      value: toScoreLetter(data?.nutriscoreLetterV2 ?? data.nutriscoreLetter),
      isV2: !!data?.nutriscoreLetterV2,
    },
    ...((duration > 0 || data?.tagsCookingTime?.[0]?.name) && {
      duration:
        duration > 0
          ? t('recipe_duration', { duration })
          : data?.tagsCookingTime?.[0]?.name,
    }),
  }
}

export default RecipeHeroTransform
